__turbopack_context__.v({
  "icons_block": "UQfUKa_icons_block",
  "icons_block__code": "UQfUKa_icons_block__code",
  "icons_block__description": "UQfUKa_icons_block__description",
  "icons_block__icon": "UQfUKa_icons_block__icon",
  "icons_block__row": "UQfUKa_icons_block__row",
});
